module.exports = __webpack_public_path__ + "img/294.4cb88a57.jpg";